import { COLOR_SCHEME_CHANGE } from 'constants/actionTypes';

export const colorSchemeReducer = (state = 'standart', action) => {
    switch(action.type) {
        case COLOR_SCHEME_CHANGE:
            return action.payload;
        default:
            return state;
    }
};
